import { Component, ChangeDetectionStrategy, input, computed } from '@angular/core';

@Component({
  selector: 'widget-sinyal-cubugu',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sinyal-wrap">
      @for (bar of barlar(); track bar.idx) {
        <div
          class="bar"
          [style.height.px]="bar.yukseklik"
          [style.background]="bar.aktif ? bar.renk : 'var(--py-metin-ikincil, #444)'"
          [style.opacity]="bar.aktif ? 1 : 0.25">
        </div>
      }
    </div>
  `,
  styles: [`
    :host { display: inline-flex; align-items: center; }
    .sinyal-wrap { display: flex; align-items: flex-end; gap: 3px; height: 28px; }
    .bar {
      width: 5px; border-radius: 2px;
      transition: background 0.3s, opacity 0.3s, height 0.3s;
    }
  `],
})
export class SinyalCubuguComponent {
  seviye = input(3);
  renk = input('#52c41a');

  barlar = computed(() => {
    const s = Math.max(0, Math.min(5, this.seviye()));
    const r = this.renk();
    return Array.from({ length: 5 }, (_, i) => ({
      idx: i,
      yukseklik: 8 + i * 5,
      aktif: i < s,
      renk: r,
    }));
  });
}
